import { __read, __spreadArray } from "tslib";
/**
 * Log warning.
 */
export function warnLogger() {
    var msgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        msgs[_i] = arguments[_i];
    }
    console.warn.apply(console, __spreadArray(['[react-channel-plugin]'], __read(msgs), false));
}
/**
 * Log debugging.
 */
export function debugLogger(verbose) {
    var msgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        msgs[_i - 1] = arguments[_i];
    }
    if (!verbose) {
        return;
    }
    console.debug.apply(console, __spreadArray(['⚙️ [react-channel-plugin - debug]'], __read(msgs), false));
}
